// This Enum is number, because each State of the Data allow different automatic modifications
export enum ArFeatureDataState {
    /**
     * The system is always allowed to change the data without user interaction if UNDEFINED
     */
    UNDEFINED = 0,

    /**
     * The system shall display a loading indicator while loading
     */
    LOADING = 1,

    /**
     * The system shall display an error if the data is in error state
     */
    ERROR = 2,

    /**
     * The system is always allowed to change the data without user interaction if he has better option compared
     * to now.
     * Now the system set the data based on the data of current years annual report.
     */
    INITILIZED_WITH_CURRENT_YEAR_DATA = 3,

    /**
     * The system is always allowed to change the data without user interaction if he has better option compared
     * to now.
     * Now the system set the data based on the data of previous years annual report.
     */
    INITILIZED_FROM_PREVIOUS_YEAR = 4,
    /**
     * If the system has loaded saved data, then it should only be changed upon user input.
     * The system is always allowed to change the data without user interaction.
     */
    INITILIZED_FROM_SAVED_DATA = 5,

    /**
     * Modified data is always unsaved, so the system should try to save it before leving the page
     */
    MODIFIED = 6,
}
